import moji from "moji";

export const toHalfWidth = (value) => {
  return moji(value)
    .convert("ZE", "HE")
    .convert("ZS", "HS")
    .trim()
    .toString();
};
